import { get } from 'lodash';

const root = state =>
  get(state, 'KitchenPrepWorksheetState.createEditKitchenPrepWorksheetState');

export const getKitchenPrepItems = state =>
  get(root(state), 'kitchenItems', []);
export const getNeededPreparedQtyDiff = state =>
  get(root(state), 'neededQtyDiff', []);
export const getKitchenItemListError = state =>
  get(root(state), 'fetchKitchenItemListError', null);
export const getListLoading = state => get(root(state), 'loading', false);
export const getSubmitted = state => get(root(state), 'submitted', false);
export const getSubmitError = state => get(root(state), 'submitError', null);
export const getKitchenPrepSubmitLoading = state =>
  get(root(state), 'kitchenPrepSubmitLoading', false);
export const getSelectedKitchenPrepData = state =>
  get(root(state), 'selectedKitchenPrepData', null);
export const getKitchenPrepDetailError = state =>
  get(root(state), 'fetchingKitchenPrepDetailError', null);
export const getKitchenPrepDetailLoading = state =>
  get(root(state), 'fetchingKitchenPrepDetail', false);



// WEBPACK FOOTER //
// ./src/pages/centralkitchen/kitchenprepworksheet/state/createEditKitchenPrepWorksheet/selectors.js